import { OnInit, Output, EventEmitter,Input, Component } from "@angular/core";

@Component({
    selector: 'mydocma-co-pane-header',
    templateUrl: './co-app-pane-header.component.html',
    styleUrls: ['./co-app-pane-header.component.scss']
})
export class CoAppPaneHeaderComponent implements OnInit {

    @Input() headerText: string;
    @Input() doneVisible = true;
    @Input() doneEnabled = true;
    @Input() locked = false;
    @Input() continueMode = false;

    @Output() closeClick = new EventEmitter();
    @Output() doneClick = new EventEmitter();



    constructor() {

    }

    ngOnInit(): void {
    }

}
